import axios from 'axios';
import {baseApiUrl} from "../../../mainConfig.js";
const state = {
  accessToken: "",
  activeTabFlags: {
    // "360Model": {
    //   label: "360 Model",
    //   value: true,
    //   link: "https://360-images.geodemosolutions.com/"
    // },
    // PCStationBuilding: {
    //   label: "PC Station Building",
    //   value: false,
    //   link: "https://recap.autodesk.com/project/c61c4b8d7b34465d89fbca0d467343b0"
    // },
    // PCStationPrecinct: {
    //   label: "PC Station Precinct",
    //   value: false,
    //   link: "https://recap360.autodesk.com/project/d2bd20b8f8b54b60838c7b6d60caf141"
    // },
    "jervisBay": {
      label: "Jervis Bay",
      value: true,
      link: "https://jbr-360pv.geodemosolutions.com/",
      imageLink: "img/JBR.png"
    },
    // "erskineville": {
    //   label: "Erskineville",
    //   value: true,
    //   link: "https://esk-360projectview.geodemosolutions.com/",
    //   imageLink: "img/ESK.png"
    // },
    // "pymble": {
    //   label: "Pymble",
    //   value: true,
    //   link: "https://pym-360projectview.geodemosolutions.com/",
    //   imageLink: "img/PYM.png"
    // },
    // "thornleigh": {
    //   label: "Thornleigh",
    //   value: true,
    //   link: "https://thn-360projectview.geodemosolutions.com/",
    //   imageLink: "img/THN.png"
    // },
    // "normanhurst": {
    //   label: "Normanhurst",
    //   value: true,
    //   link: "https://nmh-360projectview.geodemosolutions.com/",
    //   imageLink: "img/NMH.png"
    // },
  }
}
function initialState () {
  return {
    accessToken: "",
    activeTabFlags: {
      // "360Model": {
      //   label: "360 Model",
      //   value: true,
      //   link: "https://360-images.geodemosolutions.com/"
      // },
      // PCStationBuilding: {
      //   label: "PC Station Building",
      //   value: false,
      //   link: "https://recap.autodesk.com/project/c61c4b8d7b34465d89fbca0d467343b0"
      // },
      // PCStationPrecinct: {
      //   label: "PC Station Precinct",
      //   value: false,
      //   link: "https://recap360.autodesk.com/project/d2bd20b8f8b54b60838c7b6d60caf141"
      // },
      "jervisBay": {
        label: "Jervis Bay",
        value: true,
        link: "https://jbr-360pv.geodemosolutions.com/",
        imageLink: "img/JBR.png"
      },
      // "erskineville": {
      //   label: "Erskineville",
      //   value: true,
      //   link: "https://esk-360projectview.geodemosolutions.com/",
      //   imageLink: "img/ESK.png"
      // },
      // "pymble": {
      //   label: "Pymble",
      //   value: true,
      //   link: "https://pym-360projectview.geodemosolutions.com/",
      //   imageLink: "img/PYM.png"
      // },
      // "thornleigh": {
      //   label: "Thornleigh",
      //   value: true,
      //   link: "https://thn-360projectview.geodemosolutions.com/",
      //   imageLink: "img/THN.png"
      // },
      // "normanhurst": {
      //   label: "Normanhurst",
      //   value: true,
      //   link: "https://nmh-360projectview.geodemosolutions.com/",
      //   imageLink: "img/NMH.png"
      // },
    }
  }
}
const mutations = {
  storeAccessToken(state, payload) {
    state.accessToken = payload
  },
  setActiveTabFlag(state, payload) {
    Object.keys(state.activeTabFlags).forEach(item=>{
      state.activeTabFlags[item].value = false
    })
    state.activeTabFlags[payload].value = true
  }
}
const actions = {
  async login({dispatch, commit}, payload) {
    return new Promise(function(resolve, reject) {
      let loginUrl = baseApiUrl+"login"
      let config = {
        responseType: 'json'
      }
      axios.post(loginUrl, payload, config).then(result=>{
        if (typeof(result.data) != "undefined" && typeof(result.data.successfulLogin)!= "undefined" && result.data.successfulLogin == true) {
          resolve(result.data.accessToken)
        }
        else {
          reject("Invalid Login")
        }
      }).catch(error=>{
        reject("Invalid Login")
      })
    });
  }
}
const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
